import { isOnPremise } from "@/env/env";

export const useOnPremise = () => {
  const isOnPremiseValue = isOnPremise();

  return { isOnPremise: isOnPremiseValue };
};
